module.exports = __webpack_public_path__ + "static/img/张太浩 油画素描.5b4eae85.png";